import { CSSProperties } from "react";
import styled from "styled-components";
import theme from "styles/theme";

export const SelectField: CSSProperties = {
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
  height: theme["@height-input-lg"],
};

export const FilterOptionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 32px;
  margin-bottom: 20px;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: ${(props) => props.theme["@height-input-lg"]} !important;
  }
  .ant-select.ant-tree-select.ant-select-multiple {
    margin-top: 8px !important;
  }
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    border-right-width: 0;
    background-color: ${(props) => props.theme["@hover-input-wrapper"]} !important;
  }

  .ant-select-multiple .ant-select-selection-item {
    border-radius: 17px !important;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]} !important;
    }
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    grid-auto-flow: row;

    & > :nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }
    & > :nth-child(2) {
      grid-column: 2;
      grid-row: 1;
    }
    & > :nth-child(3) {
      grid-column: 1;
      grid-row: 2;
    }
    & > :nth-child(4) {
      grid-column: 2;
      grid-row: 2;
    }
  }
`;

export const ButtonsFilter = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 32px;
  align-items: end;
  .ant-btn-primary {
    height: ${(props) => props.theme["@height-button-lg"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: none;
    color: ${(props) => props.theme.colors.text};
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      color: ${(props) => props.theme.colors.text};
      border: none;
    }
  }
  .tertiaryButton {
    height: ${(props) => props.theme["@height-button-lg"]};
    color: ${(props) => props.theme.colors.text};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1.6px solid ${(props) => props.theme["@default-background"]} !important;
    display: flex;
    box-shadow: none;
    align-items: center;
    height: ${(props) => props.theme["@height-button-lg"]};
    justify-content: center;
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]} !important;
      color: ${(props) => props.theme.colors.text};
    }
    > span {
      display: flex;
    }
  }

  .secondaryButton {
    height: ${(props) => props.theme["@height-button-lg"]};
    color: ${(props) => props.theme.colors.text};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1.6px solid ${(props) => props.theme.colors.text} !important;
    height: ${(props) => props.theme["@height-button-lg"]};
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]} !important;
      color: ${(props) => props.theme.colors.text};
    }
  }

  .ant-btn[disabled],
  .ant-btn[disabled]:active,
  .ant-btn[disabled]:focus,
  .ant-btn[disabled]:hover {
    background-color: ${(props) => props.theme["@muted-background"]} !important;
    border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    color: ${(props) => props.theme["@disabled-button"]} !important;
  }
`;

export const StatusFilter = styled.div`
  display: grid;
`;

export const Label = styled.span`
  font-family: ${(props) => props.theme["@font-family"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
  margin-bottom: 8px !important;
`;
